module.exports = __webpack_public_path__ + "1791188489487/images/north-america.ac4661b.png";